export const DIET_LIST_REQUEST = 'DIET_LIST_REQUEST';
export const DIET_LIST_SUCCESS = 'DIET_LIST_SUCCESS';
export const DIET_LIST_FAIL = 'DIET_LIST_FAIL';
